module.exports = __webpack_public_path__ + "static/media/service.56d2a2e2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/home/service.png
 ** module id = 635
 ** module chunks = 0
 **/